var map = {
	"./arrow-down-blue.svg": 680,
	"./arrow-down-grey.svg": 681,
	"./arrow-right-white.png": 682,
	"./arrow-right.svg": 683,
	"./bgImageDarkMode.png": 357,
	"./bgImageLightMode.png": 358,
	"./big_unicorn.png": 684,
	"./blue-loader.svg": 360,
	"./bscwallet.png": 685,
	"./certik-logo.svg": 361,
	"./certik.png": 686,
	"./certik.png:Zone.Identifier": 687,
	"./circle-grey.svg": 688,
	"./circle.svg": 689,
	"./coinbaseWalletIcon.svg": 201,
	"./dropdown-blue.svg": 690,
	"./dropdown.svg": 691,
	"./dropup-blue.svg": 692,
	"./ethereum-logo.png": 362,
	"./farm/NEVER.png": 693,
	"./farm/casino_banner.gif": 363,
	"./farm/eve-ada.svg": 364,
	"./farm/eve-alpaca.png": 694,
	"./farm/eve-alpaca.svg": 365,
	"./farm/eve-bnb.svg": 272,
	"./farm/eve-btc.svg": 366,
	"./farm/eve-bunny.svg": 367,
	"./farm/eve-busd.svg": 368,
	"./farm/eve-cake.svg": 369,
	"./farm/eve-dai.svg": 370,
	"./farm/eve-dop.svg": 371,
	"./farm/eve-dot.svg": 372,
	"./farm/eve-link.svg": 373,
	"./farm/eve-scz.png": 695,
	"./farm/eve-scz.svg": 374,
	"./farm/eve-uni.svg": 375,
	"./farm/eve-usdc.svg": 376,
	"./farm/eve-usdt.svg": 377,
	"./farm/eve-ust.svg": 378,
	"./farm/eve-wad.svg": 379,
	"./farm/eve-xrp.svg": 380,
	"./farm/eve.svg": 381,
	"./farm/never-bnb.svg": 273,
	"./farm/never-busd.svg": 382,
	"./farm/never-eve.svg": 274,
	"./farm/never.svg": 45,
	"./farm/neverdie.svg": 184,
	"./farm/usdc-bnb.svg": 383,
	"./farm/usdt-bnb.svg": 384,
	"./fortmaticIcon.png": 202,
	"./landing-logo.png": 696,
	"./landing/coinmooner-logo.png": 385,
	"./landing/coinsniper-logo.png": 386,
	"./landing/dapp-logo.png": 387,
	"./landing/hero-bg.png": 388,
	"./link.svg": 697,
	"./logo-footer.svg": 389,
	"./logo.png": 698,
	"./logo.svg": 699,
	"./magnifying-glass.svg": 700,
	"./menu.svg": 701,
	"./metamask.png": 359,
	"./neverswap-logo.png:Zone.Identifier": 702,
	"./noise.png": 390,
	"./plus-blue.svg": 703,
	"./plus-grey.svg": 704,
	"./portisIcon.png": 203,
	"./question-mark.svg": 705,
	"./question.svg": 706,
	"./spinner.svg": 707,
	"./telegram-logo.svg": 391,
	"./token-list/lists-dark.png": 708,
	"./token-list/lists-light.png": 709,
	"./token-logo.png": 710,
	"./token-logo.svg": 205,
	"./trustwallet.png": 711,
	"./tvl-bg.svg": 392,
	"./twitter-logo.svg": 393,
	"./walletConnectIcon.svg": 204,
	"./x.svg": 712
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 219;